import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import ActionDetailModal from '@/components/container/modal/automationReview/ActionDetailModal'

interface ActionDetailModalState {
  siteId: number
  actionId: number
  onChanged?: () => void
}

const defaultValue: ActionDetailModalState = { siteId: 0, actionId: 0, onChanged: undefined }

export const ActionDetailModalContext = createModalContext<ActionDetailModalState>(defaultValue)

const ActionDetailModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<ActionDetailModalState>(defaultValue)
  return (
    <ActionDetailModalContext.Provider value={state}>
      {children}
      <ActionDetailModal />
    </ActionDetailModalContext.Provider>
  )
}

export default ActionDetailModalProvider
